import { useCallback, useRef } from 'react';
import { addMinutesToClock, normalizeClockValue, timeToMinutes } from '../lib/plannerPriorityValidation';

const createUntouchedPriorityMap = (priorities = []) => (priorities || []).reduce((acc, _, index) => {
  acc[index] = false;
  return acc;
}, {});

export const usePlannerPriorityTimeNormalization = ({ plan, setPlan }) => {
  const priorityTimeTouchedRef = useRef({});

  const initializePriorityTimeState = useCallback((priorities = []) => {
    priorityTimeTouchedRef.current = createUntouchedPriorityMap(priorities);
  }, []);

  const normalizePriorityFieldValue = useCallback((field, value) => {
    if (field === 'start_time' || field === 'end_time') {
      return normalizeClockValue(value);
    }

    return value;
  }, []);

  const registerPendingEndTimeNormalization = useCallback((index) => {
    if (priorityTimeTouchedRef.current[index]) return;

    setPlan((prev) => {
      if (!prev) return prev;
      if (priorityTimeTouchedRef.current[index]) return prev;

      const priorities = [...(prev.priorities || [])];
      const current = priorities[index] || {};
      const previousEnd = index > 0 ? priorities[index - 1]?.end_time : null;
      const hasFinalTimeValue = timeToMinutes(current.end_time) !== null;
      const hasComparablePreviousEnd = !previousEnd || timeToMinutes(previousEnd) !== null;

      if (!hasFinalTimeValue || !hasComparablePreviousEnd) {
        return prev;
      }

      priorityTimeTouchedRef.current[index] = true;

      if (
        previousEnd
        && timeToMinutes(current.end_time) !== null
        && timeToMinutes(previousEnd) !== null
        && timeToMinutes(current.end_time) <= timeToMinutes(previousEnd)
      ) {
        priorities[index] = {
          ...current,
          start_time: previousEnd,
          end_time: addMinutesToClock(previousEnd, 30),
        };

        return { ...prev, priorities };
      }

      return prev;
    });
  }, [setPlan]);

  return {
    initializePriorityTimeState,
    normalizePriorityFieldValue,
    registerPendingEndTimeNormalization,
  };
};